export default "__VITE_ASSET__DmvftvF2__"